import {
  MANAGER_ID_FETCHING,
  MANAGER_ID_FAILED,
  MANAGER_ID_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MANAGER_ID_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case MANAGER_ID_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case MANAGER_ID_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
